class UnimicroController extends AbstractIntegrationController
	@register()
	@inject '$window',
		'configuration'
		'configurationOptions'
		'IntegrationService'
		'IntegrationRepository'
		'VatRates'
		'TenderTypes'
		'ToastService'
		'ProductCategories'
		'ProductRepository'
		'Shops'
		'BACKEND_UNIMICRO_ACTION'
		'BACKEND_UNIMICRO_ENVIRONMENT'
		'translate'
		'kebabCaseToSnakeCase'

	integrationId: 'unimicro'

	initialize: ->
		index = 0

		@unimicroEnvironments = _.map @BACKEND_UNIMICRO_ENVIRONMENT, (environment) =>
			id: environment
			index: index++
			name: @translate('wbo.integration.unimicro.environment.' + environment)

		@unimicroActions = _.map @BACKEND_UNIMICRO_ACTION, (action) =>
			id: action
			name: @translate('wbo.integration.unimicro.journal_action.' + @kebabCaseToSnakeCase(action))

		if _.isEmpty @configurationOptions
			return

		@isActive = @configuration.is_active
		@defaultValueId = 'default'
		@environment = null

		@ensureObjectsInConfiguration(@configuration, ['mappings', 'settings'])
		@normalizeShopsMapping()

		if _.isEmpty @configuration.settings.journal_action
			@configuration.settings.journal_action = @BACKEND_UNIMICRO_ACTION.BOOK_JOURNAL_ENTRIES

		@category = null
		@categories = []

		@actions =
			save: @isActive
			disconnect: true

		@filterDTO = new FilterDTO(
			searchConfiguration:
				name:
					property: 'name',
					label: 'general.name'
			page_size: 25
			count: 0
			page: 1
		)

		@vatRates = @VatRates.data
		@tenderTypes = @TenderTypes.data
		@shops = @Shops.data ? []
		@productCategories = _.filter @ProductCategories.data, (category) -> category.parent_id == null
		@paymentAccounts = @IntegrationService.getPaymentAccounts()

		for shop in @shops
			@configuration.mappings.shops[shop.id] ?= null

		@initializeTabs()

	initializeTabs: ->
		@tabs = [
			{
				title: 'wbo.integration.unimicro.tab.general'
				selector: '#tab-unimicro-general'
			},
			{
				title: 'wbo.integration.unimicro.tab.product'
				selector: '#tab-unimicro-product'
			},
			{
				title: 'wbo.integration.unimicro.tab.payment'
				selector: '#tab-unimicro-payment'
			},
			{
				title: 'general.shops'
				selector: '#tab-unimicro-shop'
			},
			{
				title: 'wbo.integration.unimicro.tab.vat'
				selector: '#tab-unimicro-vat'
			},
		]

	save: ->
		@normalizeShopsMapping()

		super @configuration

	afterDisconnect: ->
		@isActive = false
		@configuration = {}

	goToAuthorizationPage: ->
		query = @IntegrationRepository.createQuery()
		query.addParameter('environment', @environment)

		@IntegrationRepository
			.fetch("/#{@integrationId}/authorization/url", query)
			.then (response) =>
				@$window.location.href = response.data.url
			.catch (response) =>
				@handleErrors(response)

	updateChildCategoriesList: ->
		if @category == null
			return

		@categories = [@category]

		@categories.push(...@getChildCategories(@category.id))

	getChildCategories: (parentId) ->
		categories = _.filter @ProductCategories.data, (category) -> category.parent_id == parentId

		for category in categories
			categories.push(...@getChildCategories(category.id));

		return categories

	searchProducts: ->
		query = @filterDTO.getQuery()

		@ProductRepository
			.getEntitiesWithCount query, true
			.then (response) =>
				@filterDTO.count = response.count
				@products = response.data

	runIntegration: (timestampFrom, timestampTo) ->
		@saving = true

		requestBody =
			timestamp_from: timestampFrom
			timestamp_to: timestampTo

		@IntegrationRepository
			.run @integrationId, requestBody
			.then =>
				@ToastService.add(
					@$filter('translate')(@headerText).toString(),
					@$filter('translate')('general.integration'),
					@$filter('translate')('general.operation.success'),
					'success'
				)
			.catch (response) =>
				@handleErrors(response)
			.finally =>
				@saving = false

	onProductPageSizeChange: (pageSize) ->
		@filter.page_size = pageSize

		@search()

	getAvailableDimensionsForShop: (shopId) ->
		selectedDimensionId = @configuration.mappings.shops[shopId]

		return _.filter @configurationOptions.dimensions ? [], (dimension) =>
			dimension.id == selectedDimensionId || !@isDimensionAssignedElsewhere(shopId, dimension.id)

	isDimensionAssignedElsewhere: (shopId, dimensionId) ->
		for id, mappedDimensionId of @configuration.mappings.shops ? {}
			if id == shopId
				continue

			if mappedDimensionId == dimensionId
				return true

		return false

	normalizeShopsMapping: ->
		if !_.isObject(@configuration.mappings?.shops) || Array.isArray(@configuration.mappings.shops)
			@configuration.mappings.shops = {}

		@configuration.mappings.shops = _.reduce @configuration.mappings.shops, (result, shopMapping, shopId) ->
			dimensionId = null

			if _.isObject(shopMapping) && !Array.isArray(shopMapping)
				dimensionId = shopMapping.dimension_id ? null
			else if shopMapping?
				dimensionId = shopMapping

			result[shopId] = dimensionId

			return result
		, {}
